var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goodPriceEditPage" },
    [
      _c("el-page-header", {
        attrs: { content: _vm.title },
        on: { back: _vm.close },
      }),
      _c(
        "div",
        { staticClass: "content overflow-y-auto" },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              staticClass: "overflow-y-auto",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "110px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _vm.form.applyMethod === 1
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "调价方式：", prop: "adjustType" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: _vm.isReadonly },
                            on: { input: _vm.searchPrice },
                            model: {
                              value: _vm.form.adjustType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "adjustType", $$v)
                              },
                              expression: "form.adjustType",
                            },
                          },
                          [
                            _c(
                              "el-radio",
                              { attrs: { label: "fixed_value" } },
                              [_vm._v("固定值调整")]
                            ),
                            _c(
                              "el-radio",
                              { attrs: { label: "percent_value" } },
                              [_vm._v("百分比调整")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "调整价格类型：",
                          prop: "adjustPriceType",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: _vm.isReadonly },
                            on: { input: _vm.searchPrice },
                            model: {
                              value: _vm.form.adjustPriceType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "adjustPriceType", $$v)
                              },
                              expression: "form.adjustPriceType",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "cost_base" } }, [
                              _vm._v("在成本基础上调整"),
                            ]),
                            _c("el-radio", { attrs: { label: "sale_base" } }, [
                              _vm._v("在售价基础上调整"),
                            ]),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "tips text-red-500 mt-2" }, [
                          _c("div", [
                            _vm._v(
                              " 在成本基础上调整：调整值直接修改成本价，成本价修改后，然后再计算基础成本、化债和抵扣金额，最后计算商城售价。 "
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              "在售价基础上调整：调整值直接修改商城售价。"
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm.form.adjustPriceType === "cost_base"
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "调整目标：", prop: "adjustTag" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { disabled: _vm.isReadonly },
                                on: { input: _vm.searchPrice },
                                model: {
                                  value: _vm.form.adjustTag,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "adjustTag", $$v)
                                  },
                                  expression: "form.adjustTag",
                                },
                              },
                              [
                                _c(
                                  "el-radio",
                                  {
                                    attrs: { label: "original_profit_amount" },
                                  },
                                  [_vm._v("保持原利润额")]
                                ),
                                _c(
                                  "el-radio",
                                  { attrs: { label: "original_sales_profit" } },
                                  [_vm._v("保持原销售利润率")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "tips text-red-500 mt-2" },
                              [
                                _c("div", [
                                  _vm._v(
                                    "保持原利润额：优先保证单品利润绝对值，适合薄利多销的商品。"
                                  ),
                                ]),
                                _c("div", [
                                  _vm._v(
                                    "保持原销售利润率：保证利润占售价的比例，适合高毛利、品牌类商品。"
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "调整值：", prop: "adjustPriceValue" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "adjustPriceValue" },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "90px" },
                                attrs: {
                                  size: "small",
                                  disabled: _vm.isReadonly,
                                },
                                on: { change: _vm.searchPrice },
                                model: {
                                  value: _vm.form.adjustPriceSymbol,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "adjustPriceSymbol", $$v)
                                  },
                                  expression: "form.adjustPriceSymbol",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "增加", value: "add" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "减少", value: "sub" },
                                }),
                              ],
                              1
                            ),
                            _c("el-input-number", {
                              staticClass: "adjustNumber",
                              attrs: {
                                size: "small",
                                min: 0,
                                precision: 2,
                                step: 0.1,
                                "controls-position": "right",
                                disabled: _vm.isReadonly,
                              },
                              on: { change: _vm.searchPrice },
                              model: {
                                value: _vm.form.adjustPriceValue,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "adjustPriceValue", $$v)
                                },
                                expression: "form.adjustPriceValue",
                              },
                            }),
                            _c("span", { staticClass: "ml-2" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.adjustType === "fixed_value"
                                    ? "元"
                                    : "%"
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                : _vm.form.applyMethod === 4
                ? [
                    _c("div", { staticClass: "tips-section" }, [
                      _c("p", [
                        _vm._v(
                          "商品批量调价：勾选的商品，进行批量修改价格，支持取竞品不同的价格进行调整"
                        ),
                      ]),
                      _c("p", { staticClass: "indent" }, [
                        _vm._v("提交的调价单，在商品调价管理查询"),
                      ]),
                      _c("p", { staticClass: "indent" }, [
                        _vm._v("调价单审核，在商品调价审核功能进行审核管理"),
                      ]),
                    ]),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "调价取值：",
                          prop: "adjustTakePriceType",
                          required: "",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: _vm.isReadonly },
                            on: { change: _vm.searchPrice },
                            model: {
                              value: _vm.form.adjustTakePriceType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "adjustTakePriceType", $$v)
                              },
                              expression: "form.adjustTakePriceType",
                            },
                          },
                          _vm._l(_vm.priceSourceOptions, function (item) {
                            return _c(
                              "el-radio",
                              { key: item.value, attrs: { label: item.value } },
                              [_vm._v(" " + _vm._s(item.label) + " ")]
                            )
                          }),
                          1
                        ),
                        _c("div", { staticClass: "form-tip" }, [
                          _vm._v("当前平台竞品产品为 京东和淘宝两家"),
                        ]),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "调价原因：", prop: "adjustReason" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidth",
                      attrs: {
                        size: "small",
                        placeholder: "请选择",
                        disabled: _vm.isReadonly,
                      },
                      model: {
                        value: _vm.form.adjustReason,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "adjustReason", $$v)
                        },
                        expression: "form.adjustReason",
                      },
                    },
                    _vm._l(_vm.reasonOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注信息：", prop: "remark" } },
                [
                  _c("el-input", {
                    staticClass: "remarkInput",
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      maxlength: "200",
                      "show-word-limit": "",
                      placeholder: "请输入备注信息",
                      disabled: _vm.isReadonly,
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "remark",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            2
          ),
          _c("el-divider", { attrs: { "content-position": "left" } }, [
            _vm._v("选择调价商品"),
          ]),
          !_vm.isReadonly
            ? _c(
                "div",
                { staticClass: "mt-4 mb-4" },
                [
                  _vm.form.applyMethod !== 4
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.openChooseGoods },
                        },
                        [_vm._v("选择商品")]
                      )
                    : _vm._e(),
                  _c(
                    "el-popconfirm",
                    {
                      attrs: { title: "确认移除选中商品吗？" },
                      on: { confirm: _vm.handleBatchRemove },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "reference",
                            size: "mini",
                            disabled: _vm.selectedRows.length === 0,
                          },
                          slot: "reference",
                        },
                        [_vm._v("批量移除")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-table",
            {
              attrs: { data: _vm.currenttable, size: "small", height: "300" },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              !_vm.isReadonly
                ? _c("el-table-column", {
                    attrs: { type: "selection", width: "45", fixed: "left" },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  type: "index",
                  width: "50",
                  index: function (index) {
                    return (
                      (_vm.listPram.page - 1) * _vm.listPram.limit + index + 1
                    )
                  },
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商品ID",
                  prop: "productId",
                  "min-width": "80",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商品名称",
                  prop: "productName",
                  "min-width": "200",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "规格名称",
                  prop: "specName",
                  "min-width": "140",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "分类",
                  prop: "categoryName",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "最新售价",
                  "min-width": "100",
                  "label-class-name": "bg-red-300",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "¥ " + _vm._s(_vm.formatMoney(scope.row.latestPrice))
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "调整幅度",
                  "min-width": "150",
                  "label-class-name": "bg-red-300",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: _vm.getAdjustColorClass(
                              scope.row.adjustRange
                            ),
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.adjustRange) +
                                "（" +
                                _vm._s(scope.row.percentAdjustRange) +
                                "%） "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商城售价", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v("¥ " + _vm._s(_vm.formatMoney(scope.row.price))),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "成本价", "min-width": "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v("¥ " + _vm._s(_vm.formatMoney(scope.row.cost))),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "基础成本", "min-width": "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "¥ " + _vm._s(_vm.formatMoney(scope.row.baseCost))
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "建议售价", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "¥ " + _vm._s(_vm.formatMoney(scope.row.otPrice))
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "库存", prop: "stock", "min-width": "80" },
              }),
              _c("el-table-column", {
                attrs: { label: "销量", prop: "sales", "min-width": "80" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "最近调价时间",
                  prop: "lastAdjustPriceTime",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "120", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !_vm.isReadonly
                          ? [
                              _c(
                                "el-popconfirm",
                                {
                                  attrs: { title: "确认移除该商品吗？" },
                                  on: {
                                    confirm: function ($event) {
                                      return _vm.removeRow(scope.row)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: { slot: "reference" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeRow(scope.row)
                                        },
                                      },
                                      slot: "reference",
                                    },
                                    [_vm._v("移除")]
                                  ),
                                ]
                              ),
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                            ]
                          : _vm._e(),
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openAdjustRecord(scope.row)
                              },
                            },
                          },
                          [_vm._v("调价记录")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.tableData.length,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
          _vm.isReadonly
            ? _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("其他信息"),
              ])
            : _vm._e(),
          _vm.isReadonly
            ? _c(
                "el-descriptions",
                { staticClass: "mb-10" },
                [
                  _c("el-descriptions-item", { attrs: { label: "申请人" } }, [
                    _vm._v(_vm._s(_vm.otherData.applicantName)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "申请时间" } }, [
                    _vm._v(_vm._s(_vm.otherData.applyTime)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "审批人" } }, [
                    _vm._v(_vm._s(_vm.otherData.approverName)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "审批时间" } }, [
                    _vm._v(" " + _vm._s(_vm.otherData.approveTime) + " "),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "审核备注" } }, [
                    _vm._v(" " + _vm._s(_vm.otherData.approveRemark)),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.chooseGoodsVisible,
                title: "选择商品",
                "append-to-body": "",
                "destroy-on-close": "",
                "close-on-click-modal": false,
                width: "1500px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.chooseGoodsVisible = $event
                },
              },
            },
            [
              _c("choose-goods", {
                attrs: { "init-goods-list": _vm.tableData },
                on: {
                  hideGoodsDialog: function ($event) {
                    _vm.chooseGoodsVisible = false
                  },
                  submitGoodsList: _vm.handleGoodsSelection,
                },
              }),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.recordVisible,
                title: "调价记录",
                "append-to-body": "",
                "destroy-on-close": "",
                "close-on-click-modal": false,
                width: "1200px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.recordVisible = $event
                },
              },
            },
            [
              _c(
                "el-descriptions",
                { staticClass: "mb-10" },
                [
                  _c("el-descriptions-item", { attrs: { label: "商品 ID" } }, [
                    _vm._v(_vm._s(_vm.recordData.productId)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "品牌" } }, [
                    _vm._v(_vm._s(_vm.recordData.brandName)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "商品名称" } }, [
                    _vm._v(_vm._s(_vm.recordData.productName)),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "规格名称" } },
                    [
                      _vm.recordData.specName
                        ? [_vm._v(_vm._s(_vm.recordData.specName))]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c("el-descriptions-item", { attrs: { label: "上下架" } }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.recordData.isShow === 0 ? "下架" : "上架")
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-table",
                { attrs: { data: _vm.recordData.recordList, size: "small" } },
                [
                  _c("el-table-column", {
                    attrs: { label: "序号", type: "index", width: "50" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "原价格",
                      prop: "originalPrice",
                      "min-width": "80",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "新价格",
                      prop: "newPrice",
                      "min-width": "200",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "调整幅度",
                      prop: "adjustRangeRate",
                      "min-width": "140",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作时间",
                      prop: "operateTime",
                      "min-width": "170",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "调价申请方式",
                      prop: "applyMethod",
                      "min-width": "170",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "调价原因",
                      prop: "adjustReason",
                      "min-width": "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作人",
                      prop: "operator",
                      "min-width": "100",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "dialog-footer" }, [
        _c(
          "div",
          [
            _vm.isCreate !== 2
              ? _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")])
              : _vm._e(),
            _vm.isApprove
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handlerAudit },
                  },
                  [_vm._v("提交审核")]
                )
              : _vm._e(),
            _vm.isCreate === 0
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handlerSubmit },
                  },
                  [_vm._v("提交")]
                )
              : _vm.isCreate === 1
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handlerSubmit },
                  },
                  [_vm._v("保存")]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }